import React from "react";
import { Container, Row, Col } from "shards-react";
import {firebases,files } from '../config';
import PageTitle from "../components/common/PageTitle";
import FormItem from "../components/common/FormItem";


const baseName = "Chapters";
const firebaseDb = firebases.database().ref().child('chapters');
const firebaseDbCategory = firebases.database().ref().child('subCategory');
const firebaseCategoryDb = firebases.database().ref().child('category');
const firebaseLinkedList = [firebaseCategoryDb,firebaseDbCategory];
const header = [{"field":"title","label":"Title","sort":"asc","type":"TEXT","editType":"textview"},{"field":"icon","label":"Icon","sort":"asc","type":"IMAGE","editType":"file"},
{"field":"description","label":"Description","sort":"asc","type":"EDITOR","editType":"EDITOR"},
{"field":"learnings","label":"What You Will Learn","sort":"asc","type":"EDITOR","editType":"EDITOR"},

{
  label: 'Video ID',
  field: 'video',
  sort: 'asc',
  width: 270,
  type:"TEXT"
}
,{
  label: 'Board Exam Weightage',
  field: 'weightage',
  sort: 'asc',
  width: 270,
  type:"TEXT",
  "editType":"number"
},
{
  label: 'Difficulty',
  field: 'difficulty',
  sort: 'asc',
  width: 270,
  type:"SELECT",
  "editType":"SELECT",
  "options":[{name:'EXTREME',value:'EXTREME'},{name:'HARD',value:'HARD'},{name:'MODERATE',value:'MODERATE'},{name:'EASY',value:'EASY'}]

}
,{
  label: 'Questions Count',
  field: 'questionsCount',
  sort: 'asc',
  width: 270,
  type:"TEXT",
  "editType":"number"
}
,{
  label: 'Exercise Count',
  field: 'exercisesCount',
  sort: 'asc',
  width: 270,
  type:"TEXT",
  "editType":"number"
}
,{
  label: 'Concepts Count',
  field: 'conceptsCount',
  sort: 'asc',
  width: 270,
  type:"TEXT",
  "editType":"number"
}
,{
  label: 'Example Count',
  field: 'examplesCount',
  sort: 'asc',
  width: 270,
  type:"TEXT",
  "editType":"text"
}
,{
  label: 'Exam Appearence',
  field: 'examFrequency',
  sort: 'asc',
  width: 270,
  type:"TEXT",
  "editType":"text"
}
,{
  label: 'Time (mins)',
  field: 'time',
  sort: 'asc',
  width: 270,
  type:"TEXT",
  "editType":"text"
}
,{
  label: 'Ratings',
  field: 'ratings',
  sort: 'asc',
  width: 270,
  type:"RATINGS",
  "editType":"text"
},

{
  label: 'Class',
  field: 'category',
  sort: 'asc',
  width: 270,
  editType:"LINKEDLIST",
  filter:"subCategory",
  filterId:"category",
  options:[]
},
{
  label: 'Subject',
  field: 'subCategory',
  sort: 'asc',
  width: 270,
  editType:"LINKEDLIST1",
  options:[]
},{"label":"Actions","field":"actions","sort":"asc","width":110,"type":"ACTIONS"}];
let context = null;

const SubCategoryAdd = () => (
  <Container fluid className="main-content-container px-4">
    <Row noGutters className="page-header py-4">
      <PageTitle title="Chapter" subtitle="Add New Chapter" sm="4" className="text-sm-left" />
    </Row>
    <Row>
    
      <Col lg="10">
        <FormItem title="Chapter Details" model={header}   firebaseLinkedList = {firebaseLinkedList} action="Add New Chapter" firebaseDb={firebaseDb} firebaseStorage={files}/>
      </Col>
    </Row>
  </Container>
);

export default SubCategoryAdd;
